const AppValidationVotingPreload = ({
  shouldHaveButton = false,
}: {
  shouldHaveButton?: boolean;
}) => {
  return (
    <>
      <div className="w-full h-[180px] skeleton-block"></div>
      {shouldHaveButton && <div className="h-[50px] w-full rounded-full skeleton-block mt-4" />}
    </>
  );
};

export default AppValidationVotingPreload;
